import React, { ReactElement } from 'react';
import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import COLORS from '../../../constants/COLORS';
import type { IStateController } from '../../../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../../../lib/widget/state/state.types';

const Message = styled.div<{ position: string }>`
  display: block;
  position: absolute;
  left: 50%;
  padding: 4px 8px;
  white-space: nowrap;
  background: rgba(21, 16, 53, 0.9);
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  z-index: 1;
  transform: translateX(-50%);

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    width: 0;
    height: 0;
    transform: translateX(-50%);
  }

  ${({ position }) => {
    if (position === 'top') {
      return css`
        bottom: 100%;
        margin-top: 0;
        margin-bottom: 8px;

        &:after {
          bottom: -4px;
          border-top: 4px solid ${COLORS.BLACK};
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 0;
        }
      `;
    }

    if (position === 'bottom') {
      return css`
        top: 100%;
        margin-top: 8px;
        margin-bottom: 0;

        &:after {
          top: -4px;
          border-top: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 4px solid ${COLORS.BLACK};
        }
      `;
    }
  }}
`;

interface TooltipProps {
  message: (string | ReactElement)[];
  style?: Object;
}

const Tooltip: React.FC<TooltipProps> = ({ message, style }) => {
  const ref = useRef<HTMLDivElement>();
  const [position, setPosition] = useState('top');
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);

  useEffect(() => {
    if (ref && ref.current) {
      const offset = ref.current.offsetTop;
      if (offset < 20) setPosition('bottom');
    }
  }, [stateController.state.isFullscreen]);

  return (
    <div ref={ref}>
      <Message style={style} position={position}>
        {message}
      </Message>
    </div>
  );
};

export default Tooltip;
